import { Card, Divider, IconButton, Modal, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import moment from 'moment';
import { AppColors } from '../Utils/helper/AppColors';
import { BackIcon, CloseIcon, EyeIcon } from './Icons/Icons';
import { getColorSettings } from '../Utils/helper/commonUtils';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	bgcolor: AppColors.WHITE,
	borderRadius: 3,
	border: 'none',
};

export default function ViewNotes({ comments, campaign }) {
	// console.log('comments', comments);
	const [show, setShow] = useState(false);

	comments = comments?.sort((a, b) => {
		return new Date(b?.createdAt) - new Date(a?.createdAt);
	});

	    const localSettingColors = getColorSettings();

	
   return (
      
		<Stack>
			<EyeIcon
				cursor="pointer"
				onClick={() => {
					// console.log('waittttt');
					setShow(true);
				}}
				color={localSettingColors.fontColor}
				size={18}
			/>
			<Modal anchor="right" open={show} onClose={() => setShow(false)}>
				<Stack height="calc(100vh - 120px)" width={500} sx={style}>
					<Stack p={2} direction="row" alignItems="center" justifyContent="space-between">
						<Typography
							sx={{ fontSize: 24, fontFamily: 'Poppins', color: AppColors.HEADING_TITLE, fontWeight: 600, lineHeight: '130%' }}
						>
							Notes
						</Typography>
						<IconButton onClick={() => setShow(false)} size="small">
							<CloseIcon />
						</IconButton>
					</Stack>

					<Divider />

					<Stack height="100%" overflow="auto" py={3}>
						<Stack height="100%" overflow="auto">
							{comments?.map((comment, idx) => (
								<Stack
									key={comment?._id}
									gap={0.5}
									sx={{
										borderBottom: '1px solid #DEE2E4',
										backgroundColor: idx % 2 === 0 ? 'transparent' : '#F9F9F9',
										paddingBottom: 1,
										py: 1,
										px: 2,
									}}
								>
									<Typography
										sx={theme => ({
											fontSize: 14,
											fontFamily: 'Poppins',
											color: theme.palette.primary.darker_primary,
											fontWeight: 600,
											lineHeight: '150%',
										})}
									>
										{campaign?.name}
									</Typography>
									<Typography
										sx={theme => ({
											fontSize: 10,
											fontFamily: 'Poppins',
											color: theme.palette.primary.darker_primary,
											fontWeight: 400,
											lineHeight: '121%',
											mb: 1,
										})}
									>
										{moment(comment?.createdAt).format('MMMM D, YYYY')}
									</Typography>
									<Card sx={{ boxShadow: 'none', border: 'none', background: 'transparent', p: 0 }}>
										<Typography
											sx={{
												fontSize: 14,
												fontFamily: 'Poppins',
												color: AppColors.HEADING_TITLE2,
												fontWeight: 400,
												lineHeight: '121%',
												mb: 1,
											}}
										>
											{comment?.text}o
										</Typography>
									</Card>
								</Stack>
							))}
						</Stack>
					</Stack>
				</Stack>
			</Modal>
		</Stack>
	);
}
